import { useEffect, useRef, useState } from 'react';
export const useIntersect = ({ heightOverride, once = false, root, rootMargin = '0px', threshold = 1, } = {}) => {
    const [entry, updateEntry] = useState(null);
    const [meta, updateMeta] = useState(null);
    const [node, setNode] = useState(null);
    const observer = useRef(null);
    useEffect(() => {
        const disconnect = () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
        disconnect();
        const getMetadata = ({ intersectionRatio, intersectionRect, rootBounds, }) => {
            const isIntersecting = !!intersectionRect && !!rootBounds && intersectionRatio < threshold;
            const height = heightOverride !== null && heightOverride !== void 0 ? heightOverride : intersectionRect.height;
            const bottom = intersectionRect.top + height;
            const top = intersectionRect.top - height;
            return {
                isTopIntersecting: isIntersecting &&
                    (top <= rootBounds.top ||
                        intersectionRect.height > rootBounds.height),
                isBottomIntersecting: isIntersecting && bottom >= rootBounds.bottom,
                isLeftIntersecting: isIntersecting && intersectionRect.left <= rootBounds.left,
                isRightIntersecting: isIntersecting && intersectionRect.right >= rootBounds.right,
            };
        };
        const callback = ([updatedEntry]) => {
            updateEntry(updatedEntry);
            updateMeta(getMetadata(updatedEntry));
            if (once) {
                disconnect();
            }
        };
        const options = {
            root,
            rootMargin,
            threshold: Array.isArray(threshold) ? threshold : [threshold],
        };
        if (window.IntersectionObserver) {
            observer.current = new window.IntersectionObserver(callback, options);
        }
        if (node && observer.current) {
            observer.current.observe(node);
        }
        return disconnect;
    }, [once, node, root, rootMargin, threshold, heightOverride]);
    return [setNode, Object.assign({ entry }, meta)];
};
//# sourceMappingURL=useIntersect.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
